import React, { useState, useEffect, useContext } from "react";
import { getCompanySettings, updateCompanySettings, } from '../services/api_settings';
import { AuthContext } from '../contexts/auth';
import Swal from "sweetalert2";


const CompanyEmailSetting = () => {
  const { token } = useContext(AuthContext);
  const [originalSettings, setOriginalSettings] = useState(null);
  const [isLoadingSetting, setIsLoadingSetting] = useState(false);
  const [isCompanyEmailEnabled, setIsCompanyEmailEnabled] = useState(false);



  useEffect(() => {
    const fetchSettings = async () => {
      try {
        setIsLoadingSetting(true);

        const settings = await getCompanySettings(token, 'payrolls');       
        
        setOriginalSettings(settings);
        setIsCompanyEmailEnabled(settings?.company_email_enabled);
      } catch (err) {
        console.error("Errore durante il caricamento delle impostazioni.", err);
      } finally {
        setIsLoadingSetting(false);
      }
    };

    fetchSettings();
  }, [token]);


  const handleCheckboxChange = async (e) => {
    const newValue = e.target.checked;

    try {
      await updateCompanySettings(token, { company_email_enabled: newValue });
      setIsCompanyEmailEnabled(newValue);
      setOriginalSettings((prev) => ({
        ...prev,
        company_email_enabled: newValue,
      }));

      Swal.fire({
        icon: "success",
        title: "Salvato!",
        showConfirmButton: false,
        timer: 1000,
      });
    } catch (error) {
      console.error("Errore durante il salvataggio:", error);

      let errorMessage = "Non è stato possibile aggiornare l'impostazione. Per favore riprova.";
      if (error.response && error.response.data) {
        const errorData = error.response.data;
        const errorMessages = [];

        Object.keys(errorData).forEach((key) => {
          const messageArray = errorData[key];
          if (Array.isArray(messageArray)) {
            errorMessages.push(...messageArray);
          } else if (typeof messageArray === "string") {
            errorMessages.push(messageArray);
          }
        });

        if (errorMessages.length > 0) {
          errorMessage = errorMessages.join(" ");
        }
      }

      Swal.fire({
        icon: "error",
        title: "Errore",
        text: errorMessage,
        confirmButtonText: "OK",
      });
    }
  };

  return (
    <div className="max-w-full px-4 mx-auto">
      <div className="flex justify-between items-center py-2">
        <div className="text-sm font-semibold text-gray-900">
          Abilita ricezione email 
        </div>
        <div>
          {isLoadingSetting ? 'Caricamento...' : (
            <input
              id="email-setting-checkbox"
              type="checkbox"
              className="h-5 w-5 rounded text-indigo-600 focus:ring-indigo-600"
              checked={isCompanyEmailEnabled}
              onChange={handleCheckboxChange}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default CompanyEmailSetting;